import script from "./HMRC-Agent-Delegation.vue?vue&type=script&setup=true&lang=js"
export * from "./HMRC-Agent-Delegation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__